import clsx from 'clsx';
import Link, { type LinkProps } from 'next/link';

import css from './styles.module.css';

type ButtonOrLink = React.ButtonHTMLAttributes<HTMLButtonElement> | LinkProps;

export type ButtonProps = ButtonOrLink & {
	variant?: 'primary' | 'white' | 'outline' | 'ghost';
	size?: '48' | '72';
	shadow?: boolean;
	className?: string;
	loading?: boolean;
	disabled?: boolean;
};

export const Button = ({
	variant = 'primary',
	size = '48',
	shadow = false,
	className,
	loading = false,
	...props
}: ButtonProps) => {
	className = clsx(
		{
			// sizes
			[css.size48]: size === '48',
			[css.size72]: size === '72',

			[css.shadow]: shadow,

			[css.primary]: variant === 'primary',
			[css.white]: variant === 'white',
			[css.outline]: variant === 'outline',
			[css.ghost]: variant === 'ghost',
		},
		// display
		'flex cursor-pointer flex-row items-center justify-center gap-2',
		'transition',
		// focused
		'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
		className,
	);

	const disabled = loading || props?.disabled;

	if ('href' in props) {
		return <Link className={className} {...props} />;
	}

	return <button className={className} {...props} disabled={disabled} />;
};
